var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHmCapacityIcon = function SvgHmCapacityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C5158",
    d: "M10.5 3.5A.5.5 0 0 1 11 3h1V2a.5.5 0 0 1 1 0v1h1a.5.5 0 1 1 0 1h-1v1a.5.5 0 0 1-1 0V4h-1a.5.5 0 0 1-.5-.5m3.91 3.418A6.495 6.495 0 1 1 9.082 1.59a.5.5 0 0 1-.165.986A5.504 5.504 0 0 0 2.5 8a5.48 5.48 0 0 0 1.39 3.65 5 5 0 0 1 2.254-1.796 3 3 0 1 1 3.712 0 5 5 0 0 1 2.254 1.797 5.48 5.48 0 0 0 1.314-4.568.5.5 0 1 1 .986-.165M8 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 4a5.47 5.47 0 0 0 3.37-1.156 4 4 0 0 0-6.74 0A5.47 5.47 0 0 0 8 13.5"
  })));
};
export default SvgHmCapacityIcon;